import { useEffect, useState } from "react";
import { getCarpetforEverySport } from "../services/carpetforEverySport.service";

export const useCarpetforEverySpot = () => {
  const [carpets, setCarpets] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCarpets = async () => {
      const banners = await getCarpetforEverySport();

      const mappedData = banners
        .slice()
        .sort((a, b) => a.sequence - b.sequence)
        .map((item) => ({
          id: item.id,
          title: item.name,
          image: item.media,
          link: item.action_url,
        }));

      setCarpets(mappedData);
      setLoading(false);
    };

    fetchCarpets();
  }, []);

  return { carpets, loading };
};